import * as React from "react"
import * as Immutable from 'immutable'
type Props = {
  contents: Immutable.List<string>
  readMoreOpen: boolean
  toggleReadMore: (_:boolean) => void
}
export default (props: Props): JSX.Element => (
  <>
    <p className='home__intro' id='home_intro'>
      {require('html-react-parser')(
        props.contents.first()
      )}

      {
        !props.readMoreOpen && props.contents.count() > 1 ?
          <>
            {'\u00A0'}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                props.toggleReadMore(true)
              }}
            >
              {I18n.t('read_more_toggle')}
            </a>
          </>
        : ''
      }
    </p>
    {
      props.readMoreOpen ?
        props.contents.skip(1).map((s) => (
          <p
            className='home__intro home_intro_more'
            dangerouslySetInnerHTML={{__html: s}}
          />
        ))
      : ''
    }
  </>

)
